import React, { useEffect } from 'react'
import { addWeldingLogIdOne, getWeldersList, getWeldersEngineerList } from '../../../api/welding.api'
import * as actions from '../../../reducers/form';
import SimpleAdd from '../../../components/SimpleAdd'
import { enqueueSnackbar } from '../../../reducers/notifier'
import { useHistory } from 'react-router-dom'
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import validateProps from '../../../functions/validateProps'

const formName = 'WeldingLogIdAdd'

export default function WeldingLogIdAdd(props) {
  const history = useHistory()
  const dispatch = useDispatch()
  const arrProps = [
    {
      bp: { xs: 6 },
      field: 'date', label: 'Дата выполнения работ', type: 'text', textProps: { type: 'date' }, labelProps: { shrink: true },
    },
    {
      bp: { xs: 6 },
      field: 'shift', label: 'Смена', type: 'text',
    },
    {
      bp: { xs: 12 },
      field: 'name', label: 'Наименование соединяемых элементов марка стали', type: 'text',
      validator: [value => value !== ''], errorText: 'Поле обязательно',
    },
    {
      bp: { xs: 12 },
      field: 'place', label: 'Место или номер (по чертежу или схеме) свариваемого элемента', type: 'text',
      validator: [value => value !== ''], errorText: 'Поле обязательно',
    },
    {
      bp: { xs: 12 },
      field: 'idMarkDelivery', label: 'Отметка о сдаче и приёмке узла под сварку', type: 'autoLoad',
      textProps: {
        path: getWeldersEngineerList.path({ id: props.match.params.idProject }),
        meta: {
          field: 'idMarkDelivery',
          value: 'id',
          labelFunc: (obj) => obj.fullName
        }
      },
      validator: [value => value !== ''], errorText: 'Поле обязательно',
    },
    {
      bp: { xs: 12 },
      field: 'material', label: 'Марка применяемых сварочных материалов (проволока, флюс, электроды), номер партии ', type: 'text',
    },
    {
      bp: { xs: 12 },
      field: 'atmospheric', label: 'Атмосферные условия (температура воздуха, осадки, скорость ветра) ', type: 'text',
    },
    {
      bp: { xs: 12 },
      field: 'idWelders', label: 'Сварщик', type: 'autoLoad',
      textProps: {
        path: getWeldersList.path({ id: props.match.params.idProject }),
        meta: {
          field: 'idWelders',
          value: 'id',
          labelFunc: (obj) => obj.fullName
        }
      },
      validator: [value => value !== ''], errorText: 'Поле обязательно',
    },
    {
      bp: { xs: 12 },
      field: 'idResponsible', label: 'Ответственный за производство работ (мастера, производителя работ)', type: 'autoRedux',
      textProps: { formArr: 'idMarkDelivery' },
      validator: [value => value !== ''], errorText: 'Поле обязательно',
    },
    {
      bp: { xs: 12 },
      field: 'acceptanceMark', label: 'Отметка о приемке сварного соединения', type: 'text',
    },
    {
      bp: { xs: 12 },
      field: 'comments', label: 'Замечания по контрольной проверке (производителя работ и др.)', type: 'text',
    },
  ]
  useEffect(() => {
    dispatch(actions.formInitialize({
      date: null,
      shift: '',
      name: '',
      place: '',
      idMarkDelivery: null,
      material: '',
      atmospheric: '',
      idWelders: null,
      idResponsible: null,
      acceptanceMark: '',
      comments: '',
      errorValidate: { date: true }
    }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const handleSave = (e) => {
    const { values } = form
    e.preventDefault();
    const isError = validateProps(arrProps, values)
    dispatch(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
    if (isError.check) {
      dispatch(enqueueSnackbar({
        message: `некорректные поля`,
        options: { variant: 'error' }
      }))
      return;
    }
    dispatch(actions.formSubmitAPI({
      props: {
        date: values.date,
        shift: values.shift,
        name: values.name,
        place: values.place,
        idMarkDelivery: values.idMarkDelivery,
        material: values.material,
        atmospheric: values.atmospheric,
        idWelders: values.idWelders,
        idResponsible: values.idResponsible,
        acceptanceMark: values.acceptanceMark,
        comments: values.comments,
      },
      url: addWeldingLogIdOne.path({ idProject: props.match.params.idProject, id: props.match.params.id }),
      method: addWeldingLogIdOne.type,
      history: history
    }, formName))
  }
  return <div className='App-paper'>
    <form autoComplete="off" onSubmit={handleSave}>
      <div style={{ padding: '16px' }}>
        <SimpleAdd
          formName={formName}
          arr={arrProps}
          title='Добавить сварку'
          gridProps={{ sm: 12, md: 6 }}
        />
      </div>
      <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
      <Button type="submit" color="primary">Сохранить</Button>
    </form>
  </div>
}